import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import {WarningButton} from '../../../components';

const Container = styled.div`
  margin: 1em;
`;

const renderSelectedReason = (reason, index, onRemove, disabled) => {
    return (
        <React.Fragment key={index}>
            <li className="list-group-item">
          
            {!disabled && <WarningButton className="btn-sm" onClick={() => onRemove(reason)} disabled={disabled}>Remove</WarningButton>}
            <span>&nbsp;</span>
            {reason}
            </li>
           
        
        </React.Fragment>
        
    );
}

const NonComplianceReasonsList = ({selectedReasons, onRemove, disabled}) => {  
    return (
        <Container className="row">
            <div className="col-sm-12">
                <ul className="list-group">
                {selectedReasons.map((reason, index) => renderSelectedReason(reason, index, onRemove, disabled))}
                </ul>
            </div>
          
        </Container>
          
    );
};

NonComplianceReasonsList.propTypes = {
    selectedReasons: PropTypes.array.isRequired,
    onRemove: PropTypes.func.isRequired,
    disabled: PropTypes.bool.isRequired
};

export default NonComplianceReasonsList;


// WEBPACK FOOTER //
// ./src/modules/record/components/NonComplianceReasonsList.js